    // src/components/Navbar.js
    import React from 'react';
    import { Link } from 'react-router-dom';
    import './Navbar.css'; // Optional: for styling

    function Navbar() {
      return (
        <nav className="navbar">
          {/* <Link to="/" className="navbar-brand">My App</Link> */}
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link to="/" className="nav-link">Home</Link>
            </li>
            {/* <li className="nav-item">
              <Link to="/about" className="nav-link">About</Link>
            </li>
            <li className="nav-item">
              <Link to="/contact" className="nav-link">Contact</Link>
            </li> */}
            <li className="nav-item">
              <Link to="/resources" className="nav-link">Resources</Link>
            </li>
          </ul>
        </nav>
      );
    }

    export default Navbar;